// AuthActions
export const SET_USERNAME = 'SET_USERNAME';
export const SET_PASSWORD = 'SET_PASSWORD';
export const SET_LOGIN_ERROR = 'SET_LOGIN_ERROR';
export const LOGIN_USER_START = 'LOGIN_USER_START';
export const FETCH_LOGIN_DATA_START = 'FETCH_LOGIN_DATA_START';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_FAIL = 'LOGIN_USER_FAIL';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAIL = 'CHANGE_PASSWORD_FAIL';
export const CLOSE_CHANGE_PASSWORD = 'CLOSE_CHANGE_PASSWORD';
export const LOGOUT_USER = 'LOGOUT_USER';
export const SESSION_EXPIRED = 'SESSION_EXPIRED';
export const SET_DEVICE_LIST = 'SET_DEVICE_LIST';
export const SET_DATE_LIST = 'SET_DATE_LIST';
export const SET_CAMERAS = 'SET_CAMERAS';
export const CHANGE_USER_VIEW = 'CHANGE_USER_VIEW';

// ConfigActions
export const SET_LAYOUT = 'SET_LAYOUT';
export const SET_VIEW = 'SET_VIEW';
export const SET_ADMIN_NAV = 'SET_ADMIN_NAV';
export const SET_ALERT_MODAL = 'SET_ALERT_MODAL';

// LiveActions
export const UPDATE_CAMSET = 'UPDATE_CAMSET';
export const TOGGLE_SINGLE_VIEW = 'TOGGLE_SINGLE_VIEW';
export const TOGGLE_FULLSCREEN_VIEW = 'TOGGLE_FULLSCREEN_VIEW';
export const SET_DEFAULT_USER_VIEW = 'SET_DEFAULT_USER_VIEW';
export const UPDATE_CAMERAS_IN_VIEW = 'UPDATE_CAMERAS_IN_VIEW';
export const SHOW_UNSAVED_VIEW_MODAL = 'SHOW_UNSAVED_VIEW_MODAL';
export const SAVE_VIEW = 'SAVE_VIEW';
export const GET_ONLINE_STATUS_SUCCESS = 'GET_ONLINE_STATUS_SUCCESS';

// PreviewActions
// export const SET_EVENTS = 'SET_EVENTS';
// export const TOGGLE_FILTER = 'TOGGLE_FILTER';
// export const TOGGLE_PREVIEW = 'TOGGLE_PREVIEW';
// export const SET_EVENT_FILTER = 'SET_EVENT_FILTER';

// PlaybackActions
export const SET_PLAYBACK_DATE = 'SET_PLAYBACK_DATE';
export const SET_PLAYBACK_CAMERA = 'SET_PLAYBACK_CAMERA';
export const SET_PLAYBACK_TAGS = 'SET_PLAYBACK_TAGS';
export const SET_PLAYBACK_STARTTIME = 'SET_PLAYBACK_STARTTIME';
export const SET_PLAYBACK_ENDTIME = 'SET_PLAYBACK_ENDTIME';
export const GET_PLAYBACK_EVENTS_START = 'GET_PLAYBACK_EVENTS_START';
export const GET_PLAYBACK_EVENTS_SUCCESS = 'GET_PLAYBACK_EVENTS_SUCCESS';
export const GET_PLAYBACK_EVENTS_FAIL = 'GET_PLAYBACK_EVENTS_FAIL';
export const SET_FILTERED_EVENTS = 'SET_FILTERED_EVENTS';
export const SET_PLAYBACK_SCROLLER_OBJ = 'SET_PLAYBACK_SCROLLER_OBJ';
export const SET_SELECTED_EVENT = 'SET_SELECTED_EVENT';
export const SET_EVENT_CACHE = 'SET_EVENT_CACHE';
export const FLAG_EVENT_FOR_EXPORT = 'FLAG_EVENT_FOR_EXPORT';
export const SET_SELECTED_VIDEO_PLAYING = 'SET_SELECTED_VIDEO_PLAYING';
export const SET_SELECTED_VIDEO_PLAYING_URL = 'SET_SELECTED_VIDEO_PLAYING_URL';
export const GET_EVENT_SUCCESS = 'GET_EVENT_SUCCESS'; // currently not actively used
export const GET_BANDWIDTH_USAGE_SUCCESS = 'GET_BANDWIDTH_USAGE_SUCCESS'; // currently not actively used

// AdminActions
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_CUSTOMERS_SUCCESS = 'GET_CUSTOMERS_SUCCESS';
export const GET_SITES_SUCCESS = 'GET_SITES_SUCCESS';
export const GET_DEVICES_SUCCESS = 'GET_DEVICES_SUCCESS';
export const GET_CAMERAS_SUCCESS = 'GET_CAMERAS_SUCCESS';
export const GET_VIEWS_SUCCESS = 'GET_VIEWS_SUCCESS';
export const UPDATE_USERS = 'UPDATE_USERS';
export const UPDATE_CUSTOMERS = 'UPDATE_CUSTOMERS';
export const UPDATE_SITES = 'UPDATE_SITES';
export const UPDATE_DEVICES = 'UPDATE_DEVICES';
export const UPDATE_CAMERAS = 'UPDATE_CAMERAS';
export const UPDATE_VIEWS = 'UPDATE_VIEWS';